'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*eslint-disable */
// Do not edit!
// This file was auto-generated by create-styles.js
exports.default = {
  '0023-20E3': '2.85714% 0%',
  '0030-20E3': '71.42857% 51.42857%',
  '0031-20E3': '0% 2.85714%',
  '0032-20E3': '2.85714% 2.85714%',
  '0033-20E3': '5.71429% 0%',
  '0034-20E3': '5.71429% 2.85714%',
  '0035-20E3': '0% 5.71429%',
  '0036-20E3': '2.85714% 5.71429%',
  '0037-20E3': '5.71429% 5.71429%',
  '0038-20E3': '8.57143% 0%',
  '0039-20E3': '8.57143% 2.85714%',
  '00A9': '8.57143% 5.71429%',
  '00AE': '0% 8.57143%',
  '1F004': '2.85714% 8.57143%',
  '1F0CF': '5.71429% 8.57143%',
  '1F170': '8.57143% 8.57143%',
  '1F171': '11.42857% 0%',
  '1F17E': '11.42857% 2.85714%',
  '1F17F': '11.42857% 5.71429%',
  '1F18E': '11.42857% 8.57143%',
  '1F191': '0% 11.42857%',
  '1F192': '2.85714% 11.42857%',
  '1F193': '5.71429% 11.42857%',
  '1F194': '8.57143% 11.42857%',
  '1F195': '11.42857% 11.42857%',
  '1F196': '14.28571% 0%',
  '1F197': '14.28571% 2.85714%',
  '1F198': '14.28571% 5.71429%',
  '1F199': '14.28571% 8.57143%',
  '1F19A': '14.28571% 11.42857%',
  '1F1E6-1F1E8': '0% 14.28571%',
  '1F1E6-1F1E9': '2.85714% 14.28571%',
  '1F1E6-1F1EA': '5.71429% 14.28571%',
  '1F1E6-1F1EB': '8.57143% 14.28571%',
  '1F1E6-1F1EC': '11.42857% 14.28571%',
  '1F1E6-1F1EE': '14.28571% 14.28571%',
  '1F1E6-1F1F1': '17.14286% 0%',
  '1F1E6-1F1F2': '17.14286% 2.85714%',
  '1F1E6-1F1F4': '17.14286% 5.71429%',
  '1F1E6-1F1F7': '17.14286% 8.57143%',
  '1F1E6-1F1F9': '17.14286% 11.42857%',
  '1F1E6-1F1FA': '17.14286% 14.28571%',
  '1F1E6-1F1FC': '0% 17.14286%',
  '1F1E6-1F1FF': '2.85714% 17.14286%',
  '1F1E7-1F1E6': '5.71429% 17.14286%',
  '1F1E7-1F1E7': '8.57143% 17.14286%',
  '1F1E7-1F1E9': '11.42857% 17.14286%',
  '1F1E7-1F1EA': '14.28571% 17.14286%',
  '1F1E7-1F1EB': '17.14286% 17.14286%',
  '1F1E7-1F1EC': '20% 0%',
  '1F1E7-1F1ED': '20% 2.85714%',
  '1F1E7-1F1EE': '20% 5.71429%',
  '1F1E7-1F1EF': '20% 8.57143%',
  '1F1E7-1F1F2': '20% 11.42857%',
  '1F1E7-1F1F3': '20% 14.28571%',
  '1F1E7-1F1F4': '20% 17.14286%',
  '1F1E7-1F1F7': '0% 20%',
  '1F1E7-1F1F8': '2.85714% 20%',
  '1F1E7-1F1F9': '5.71429% 20%',
  '1F1E7-1F1FC': '8.57143% 20%',
  '1F1E7-1F1FE': '11.42857% 20%',
  '1F1E7-1F1FF': '14.28571% 20%',
  '1F1E8-1F1E6': '17.14286% 20%',
  '1F1E8-1F1E9': '20% 20%',
  '1F1E8-1F1EB': '22.85714% 0%',
  '1F1E8-1F1EC': '22.85714% 2.85714%',
  '1F1E8-1F1ED': '22.85714% 5.71429%',
  '1F1E8-1F1EE': '22.85714% 8.57143%',
  '1F1E8-1F1F1': '22.85714% 11.42857%',
  '1F1E8-1F1F2': '22.85714% 14.28571%',
  '1F1E8-1F1F3': '22.85714% 17.14286%',
  '1F1E8-1F1F4': '22.85714% 20%',
  '1F1E8-1F1F7': '0% 22.85714%',
  '1F1E8-1F1FA': '2.85714% 22.85714%',
  '1F1E8-1F1FB': '5.71429% 22.85714%',
  '1F1E8-1F1FE': '8.57143% 22.85714%',
  '1F1E8-1F1FF': '11.42857% 22.85714%',
  '1F1E9-1F1EA': '14.28571% 22.85714%',
  '1F1E9-1F1EF': '17.14286% 22.85714%',
  '1F1E9-1F1F0': '20% 22.85714%',
  '1F1E9-1F1F2': '22.85714% 22.85714%',
  '1F1E9-1F1F4': '25.71429% 0%',
  '1F1E9-1F1FF': '25.71429% 2.85714%',
  '1F1EA-1F1E8': '25.71429% 5.71429%',
  '1F1EA-1F1EA': '25.71429% 8.57143%',
  '1F1EA-1F1EC': '25.71429% 11.42857%',
  '1F1EA-1F1ED': '25.71429% 14.28571%',
  '1F1EA-1F1F7': '25.71429% 17.14286%',
  '1F1EA-1F1F8': '25.71429% 20%',
  '1F1EA-1F1F9': '25.71429% 22.85714%',
  '1F1EB-1F1EE': '0% 25.71429%',
  '1F1EB-1F1EF': '2.85714% 25.71429%',
  '1F1EB-1F1F0': '5.71429% 25.71429%',
  '1F1EB-1F1F2': '8.57143% 25.71429%',
  '1F1EB-1F1F4': '11.42857% 25.71429%',
  '1F1EB-1F1F7': '14.28571% 25.71429%',
  '1F1EC-1F1E6': '17.14286% 25.71429%',
  '1F1EC-1F1E7': '20% 25.71429%',
  '1F1EC-1F1E9': '22.85714% 25.71429%',
  '1F1EC-1F1EA': '25.71429% 25.71429%',
  '1F1EC-1F1ED': '28.57143% 0%',
  '1F1EC-1F1EE': '28.57143% 2.85714%',
  '1F1EC-1F1F1': '28.57143% 5.71429%',
  '1F1EC-1F1F2': '28.57143% 8.57143%',
  '1F1EC-1F1F3': '28.57143% 11.42857%',
  '1F1EC-1F1F6': '28.57143% 14.28571%',
  '1F1EC-1F1F7': '28.57143% 17.14286%',
  '1F1EC-1F1F9': '28.57143% 20%',
  '1F1EC-1F1FA': '28.57143% 22.85714%',
  '1F1EC-1F1FC': '28.57143% 25.71429%',
  '1F1EC-1F1FE': '0% 28.57143%',
  '1F1ED-1F1F0': '2.85714% 28.57143%',
  '1F1ED-1F1F3': '5.71429% 28.57143%',
  '1F1ED-1F1F7': '8.57143% 28.57143%',
  '1F1ED-1F1F9': '11.42857% 28.57143%',
  '1F1ED-1F1FA': '14.28571% 28.57143%',
  '1F1EE-1F1E9': '17.14286% 28.57143%',
  '1F1EE-1F1EA': '20% 28.57143%',
  '1F1EE-1F1F1': '22.85714% 28.57143%',
  '1F1EE-1F1F3': '25.71429% 28.57143%',
  '1F1EE-1F1F6': '28.57143% 28.57143%',
  '1F1EE-1F1F7': '31.42857% 0%',
  '1F1EE-1F1F8': '31.42857% 2.85714%',
  '1F1EE-1F1F9': '31.42857% 5.71429%',
  '1F1EF-1F1EA': '31.42857% 8.57143%',
  '1F1EF-1F1F2': '31.42857% 11.42857%',
  '1F1EF-1F1F4': '31.42857% 14.28571%',
  '1F1EF-1F1F5': '31.42857% 17.14286%',
  '1F1F0-1F1EA': '31.42857% 20%',
  '1F1F0-1F1EC': '31.42857% 22.85714%',
  '1F1F0-1F1ED': '31.42857% 25.71429%',
  '1F1F0-1F1EE': '31.42857% 28.57143%',
  '1F1F0-1F1F2': '0% 31.42857%',
  '1F1F0-1F1F3': '2.85714% 31.42857%',
  '1F1F0-1F1F5': '5.71429% 31.42857%',
  '1F1F0-1F1F7': '8.57143% 31.42857%',
  '1F1F0-1F1FC': '11.42857% 31.42857%',
  '1F1F0-1F1FE': '14.28571% 31.42857%',
  '1F1F0-1F1FF': '17.14286% 31.42857%',
  '1F1F1-1F1E6': '20% 31.42857%',
  '1F1F1-1F1E7': '22.85714% 31.42857%',
  '1F1F1-1F1E8': '25.71429% 31.42857%',
  '1F1F1-1F1EE': '28.57143% 31.42857%',
  '1F1F1-1F1F0': '31.42857% 31.42857%',
  '1F1F1-1F1F7': '34.28571% 0%',
  '1F1F1-1F1F8': '34.28571% 2.85714%',
  '1F1F1-1F1F9': '34.28571% 5.71429%',
  '1F1F1-1F1FA': '34.28571% 8.57143%',
  '1F1F1-1F1FB': '34.28571% 11.42857%',
  '1F1F1-1F1FE': '34.28571% 14.28571%',
  '1F1F2-1F1E6': '34.28571% 17.14286%',
  '1F1F2-1F1E8': '34.28571% 20%',
  '1F1F2-1F1E9': '34.28571% 22.85714%',
  '1F1F2-1F1EA': '34.28571% 25.71429%',
  '1F1F2-1F1EC': '34.28571% 28.57143%',
  '1F1F2-1F1ED': '34.28571% 31.42857%',
  '1F1F2-1F1F0': '0% 34.28571%',
  '1F1F2-1F1F1': '2.85714% 34.28571%',
  '1F1F2-1F1F2': '5.71429% 34.28571%',
  '1F1F2-1F1F3': '8.57143% 34.28571%',
  '1F1F2-1F1F4': '11.42857% 34.28571%',
  '1F1F2-1F1F7': '14.28571% 34.28571%',
  '1F1F2-1F1F8': '17.14286% 34.28571%',
  '1F1F2-1F1F9': '20% 34.28571%',
  '1F1F2-1F1FA': '22.85714% 34.28571%',
  '1F1F2-1F1FB': '25.71429% 34.28571%',
  '1F1F2-1F1FC': '28.57143% 34.28571%',
  '1F1F2-1F1FD': '31.42857% 34.28571%',
  '1F1F2-1F1FE': '34.28571% 34.28571%',
  '1F1F2-1F1FF': '37.14286% 0%',
  '1F1F3-1F1E6': '37.14286% 2.85714%',
  '1F1F3-1F1E8': '37.14286% 5.71429%',
  '1F1F3-1F1EA': '37.14286% 8.57143%',
  '1F1F3-1F1EC': '37.14286% 11.42857%',
  '1F1F3-1F1EE': '37.14286% 14.28571%',
  '1F1F3-1F1F1': '37.14286% 17.14286%',
  '1F1F3-1F1F4': '37.14286% 20%',
  '1F1F3-1F1F5': '37.14286% 22.85714%',
  '1F1F3-1F1F7': '37.14286% 25.71429%',
  '1F1F3-1F1FA': '37.14286% 28.57143%',
  '1F1F3-1F1FF': '37.14286% 31.42857%',
  '1F1F4-1F1F2': '37.14286% 34.28571%',
  '1F1F5-1F1E6': '0% 37.14286%',
  '1F1F5-1F1EA': '2.85714% 37.14286%',
  '1F1F5-1F1EB': '5.71429% 37.14286%',
  '1F1F5-1F1EC': '8.57143% 37.14286%',
  '1F1F5-1F1ED': '11.42857% 37.14286%',
  '1F1F5-1F1F0': '14.28571% 37.14286%',
  '1F1F5-1F1F1': '17.14286% 37.14286%',
  '1F1F5-1F1F7': '20% 37.14286%',
  '1F1F5-1F1F8': '22.85714% 37.14286%',
  '1F1F5-1F1F9': '25.71429% 37.14286%',
  '1F1F5-1F1FC': '28.57143% 37.14286%',
  '1F1F5-1F1FE': '31.42857% 37.14286%',
  '1F1F6-1F1E6': '34.28571% 37.14286%',
  '1F1F7-1F1F4': '37.14286% 37.14286%',
  '1F1F7-1F1F8': '40% 0%',
  '1F1F7-1F1FA': '40% 2.85714%',
  '1F1F7-1F1FC': '40% 5.71429%',
  '1F1F8-1F1E6': '40% 8.57143%',
  '1F1F8-1F1E7': '40% 11.42857%',
  '1F1F8-1F1E8': '40% 14.28571%',
  '1F1F8-1F1E9': '40% 17.14286%',
  '1F1F8-1F1EA': '40% 20%',
  '1F1F8-1F1EC': '40% 22.85714%',
  '1F1F8-1F1ED': '40% 25.71429%',
  '1F1F8-1F1EE': '40% 28.57143%',
  '1F1F8-1F1F0': '40% 31.42857%',
  '1F1F8-1F1F1': '40% 34.28571%',
  '1F1F8-1F1F2': '40% 37.14286%',
  '1F1F8-1F1F3': '0% 40%',
  '1F1F8-1F1F4': '2.85714% 40%',
  '1F1F8-1F1F7': '5.71429% 40%',
  '1F1F8-1F1F9': '8.57143% 40%',
  '1F1F8-1F1FB': '11.42857% 40%',
  '1F1F8-1F1FE': '14.28571% 40%',
  '1F1F8-1F1FF': '17.14286% 40%',
  '1F1F9-1F1E9': '20% 40%',
  '1F1F9-1F1EC': '22.85714% 40%',
  '1F1F9-1F1ED': '25.71429% 40%',
  '1F1F9-1F1EF': '28.57143% 40%',
  '1F1F9-1F1F1': '31.42857% 40%',
  '1F1F9-1F1F2': '34.28571% 40%',
  '1F1F9-1F1F3': '37.14286% 40%',
  '1F1F9-1F1F4': '40% 40%',
  '1F1F9-1F1F7': '42.85714% 0%',
  '1F1F9-1F1F9': '42.85714% 2.85714%',
  '1F1F9-1F1FB': '42.85714% 5.71429%',
  '1F1F9-1F1FC': '42.85714% 8.57143%',
  '1F1F9-1F1FF': '42.85714% 11.42857%',
  '1F1FA-1F1E6': '42.85714% 14.28571%',
  '1F1FA-1F1EC': '42.85714% 17.14286%',
  '1F1FA-1F1F8': '42.85714% 20%',
  '1F1FA-1F1FE': '42.85714% 22.85714%',
  '1F1FA-1F1FF': '42.85714% 25.71429%',
  '1F1FB-1F1E6': '42.85714% 28.57143%',
  '1F1FB-1F1E8': '42.85714% 31.42857%',
  '1F1FB-1F1EA': '42.85714% 34.28571%',
  '1F1FB-1F1EE': '42.85714% 37.14286%',
  '1F1FB-1F1F3': '42.85714% 40%',
  '1F1FB-1F1FA': '0% 42.85714%',
  '1F1FC-1F1EB': '2.85714% 42.85714%',
  '1F1FC-1F1F8': '5.71429% 42.85714%',
  '1F1FD-1F1F0': '8.57143% 42.85714%',
  '1F1FE-1F1EA': '11.42857% 42.85714%',
  '1F1FF-1F1E6': '14.28571% 42.85714%',
  '1F1FF-1F1F2': '17.14286% 42.85714%',
  '1F1FF-1F1FC': '20% 42.85714%',
  '1F201': '22.85714% 42.85714%',
  '1F202': '25.71429% 42.85714%',
  '1F21A': '28.57143% 42.85714%',
  '1F22F': '31.42857% 42.85714%',
  '1F232': '34.28571% 42.85714%',
  '1F233': '37.14286% 42.85714%',
  '1F234': '40% 42.85714%',
  '1F235': '42.85714% 42.85714%',
  '1F236': '45.71429% 0%',
  '1F237': '45.71429% 2.85714%',
  '1F238': '45.71429% 5.71429%',
  '1F239': '45.71429% 8.57143%',
  '1F23A': '45.71429% 11.42857%',
  '1F250': '45.71429% 14.28571%',
  '1F251': '45.71429% 17.14286%',
  '1F300': '45.71429% 20%',
  '1F301': '45.71429% 22.85714%',
  '1F302': '45.71429% 25.71429%',
  '1F303': '45.71429% 28.57143%',
  '1F304': '45.71429% 31.42857%',
  '1F305': '45.71429% 34.28571%',
  '1F306': '45.71429% 37.14286%',
  '1F307': '45.71429% 40%',
  '1F308': '45.71429% 42.85714%',
  '1F309': '0% 45.71429%',
  '1F30A': '2.85714% 45.71429%',
  '1F30B': '5.71429% 45.71429%',
  '1F30C': '8.57143% 45.71429%',
  '1F30D': '11.42857% 45.71429%',
  '1F30E': '14.28571% 45.71429%',
  '1F30F': '17.14286% 45.71429%',
  '1F310': '20% 45.71429%',
  '1F311': '22.85714% 45.71429%',
  '1F312': '25.71429% 45.71429%',
  '1F313': '28.57143% 45.71429%',
  '1F314': '31.42857% 45.71429%',
  '1F315': '34.28571% 45.71429%',
  '1F316': '37.14286% 45.71429%',
  '1F317': '40% 45.71429%',
  '1F318': '42.85714% 45.71429%',
  '1F319': '45.71429% 45.71429%',
  '1F31A': '48.57143% 0%',
  '1F31B': '48.57143% 2.85714%',
  '1F31C': '48.57143% 5.71429%',
  '1F31D': '48.57143% 8.57143%',
  '1F31E': '48.57143% 11.42857%',
  '1F31F': '48.57143% 14.28571%',
  '1F320': '48.57143% 17.14286%',
  '1F321': '48.57143% 20%',
  '1F327': '48.57143% 22.85714%',
  '1F328': '48.57143% 25.71429%',
  '1F329': '48.57143% 28.57143%',
  '1F32A': '48.57143% 31.42857%',
  '1F32B': '48.57143% 34.28571%',
  '1F32C': '48.57143% 37.14286%',
  '1F330': '48.57143% 40%',
  '1F331': '48.57143% 42.85714%',
  '1F332': '48.57143% 45.71429%',
  '1F333': '0% 48.57143%',
  '1F334': '2.85714% 48.57143%',
  '1F335': '5.71429% 48.57143%',
  '1F336': '8.57143% 48.57143%',
  '1F337': '11.42857% 48.57143%',
  '1F338': '14.28571% 48.57143%',
  '1F339': '17.14286% 48.57143%',
  '1F33A': '20% 48.57143%',
  '1F33B': '22.85714% 48.57143%',
  '1F33C': '25.71429% 48.57143%',
  '1F33D': '28.57143% 48.57143%',
  '1F33E': '31.42857% 48.57143%',
  '1F33F': '34.28571% 48.57143%',
  '1F340': '37.14286% 48.57143%',
  '1F341': '40% 48.57143%',
  '1F342': '42.85714% 48.57143%',
  '1F343': '45.71429% 48.57143%',
  '1F344': '48.57143% 48.57143%',
  '1F345': '51.42857% 0%',
  '1F346': '51.42857% 2.85714%',
  '1F347': '51.42857% 5.71429%',
  '1F348': '51.42857% 8.57143%',
  '1F349': '51.42857% 11.42857%',
  '1F34A': '51.42857% 14.28571%',
  '1F34B': '51.42857% 17.14286%',
  '1F34C': '51.42857% 20%',
  '1F34D': '51.42857% 22.85714%',
  '1F34E': '51.42857% 25.71429%',
  '1F34F': '51.42857% 28.57143%',
  '1F350': '51.42857% 31.42857%',
  '1F351': '51.42857% 34.28571%',
  '1F352': '51.42857% 37.14286%',
  '1F353': '51.42857% 40%',
  '1F354': '51.42857% 42.85714%',
  '1F355': '51.42857% 45.71429%',
  '1F356': '51.42857% 48.57143%',
  '1F357': '0% 51.42857%',
  '1F358': '2.85714% 51.42857%',
  '1F359': '5.71429% 51.42857%',
  '1F35A': '8.57143% 51.42857%',
  '1F35B': '11.42857% 51.42857%',
  '1F35C': '14.28571% 51.42857%',
  '1F35D': '17.14286% 51.42857%',
  '1F35E': '20% 51.42857%',
  '1F35F': '22.85714% 51.42857%',
  '1F360': '25.71429% 51.42857%',
  '1F361': '28.57143% 51.42857%',
  '1F362': '31.42857% 51.42857%',
  '1F363': '34.28571% 51.42857%',
  '1F364': '37.14286% 51.42857%',
  '1F365': '40% 51.42857%',
  '1F366': '42.85714% 51.42857%',
  '1F367': '45.71429% 51.42857%',
  '1F368': '48.57143% 51.42857%',
  '1F369': '51.42857% 51.42857%',
  '1F36A': '54.28571% 0%',
  '1F36B': '54.28571% 2.85714%',
  '1F36C': '54.28571% 5.71429%',
  '1F36D': '54.28571% 8.57143%',
  '1F36E': '54.28571% 11.42857%',
  '1F36F': '54.28571% 14.28571%',
  '1F370': '54.28571% 17.14286%',
  '1F371': '54.28571% 20%',
  '1F372': '54.28571% 22.85714%',
  '1F373': '54.28571% 25.71429%',
  '1F374': '54.28571% 28.57143%',
  '1F375': '54.28571% 31.42857%',
  '1F376': '54.28571% 34.28571%',
  '1F377': '54.28571% 37.14286%',
  '1F378': '54.28571% 40%',
  '1F379': '54.28571% 42.85714%',
  '1F37A': '54.28571% 45.71429%',
  '1F37B': '54.28571% 48.57143%',
  '1F37C': '54.28571% 51.42857%',
  '1F37D': '0% 54.28571%',
  '1F380': '2.85714% 54.28571%',
  '1F381': '5.71429% 54.28571%',
  '1F382': '8.57143% 54.28571%',
  '1F383': '11.42857% 54.28571%',
  '1F384': '14.28571% 54.28571%',
  '1F385': '17.14286% 54.28571%',
  '1F386': '20% 54.28571%',
  '1F387': '22.85714% 54.28571%',
  '1F388': '25.71429% 54.28571%',
  '1F389': '28.57143% 54.28571%',
  '1F38A': '31.42857% 54.28571%',
  '1F38B': '34.28571% 54.28571%',
  '1F38C': '37.14286% 54.28571%',
  '1F38D': '40% 54.28571%',
  '1F38E': '42.85714% 54.28571%',
  '1F38F': '45.71429% 54.28571%',
  '1F390': '48.57143% 54.28571%',
  '1F391': '51.42857% 54.28571%',
  '1F392': '54.28571% 54.28571%',
  '1F393': '57.14286% 0%',
  '1F394': '57.14286% 2.85714%',
  '1F395': '57.14286% 5.71429%',
  '1F396': '57.14286% 8.57143%',
  '1F397': '57.14286% 11.42857%',
  '1F398': '57.14286% 14.28571%',
  '1F399': '57.14286% 17.14286%',
  '1F39A': '57.14286% 20%',
  '1F39B': '57.14286% 22.85714%',
  '1F39C': '57.14286% 25.71429%',
  '1F39D': '57.14286% 28.57143%',
  '1F39E': '57.14286% 31.42857%',
  '1F39F': '57.14286% 34.28571%',
  '1F3A0': '57.14286% 37.14286%',
  '1F3A1': '57.14286% 40%',
  '1F3A2': '57.14286% 42.85714%',
  '1F3A3': '57.14286% 45.71429%',
  '1F3A4': '57.14286% 48.57143%',
  '1F3A5': '57.14286% 51.42857%',
  '1F3A6': '57.14286% 54.28571%',
  '1F3A7': '0% 57.14286%',
  '1F3A8': '2.85714% 57.14286%',
  '1F3A9': '5.71429% 57.14286%',
  '1F3AA': '8.57143% 57.14286%',
  '1F3AB': '11.42857% 57.14286%',
  '1F3AC': '14.28571% 57.14286%',
  '1F3AD': '17.14286% 57.14286%',
  '1F3AE': '20% 57.14286%',
  '1F3AF': '22.85714% 57.14286%',
  '1F3B0': '25.71429% 57.14286%',
  '1F3B1': '28.57143% 57.14286%',
  '1F3B2': '31.42857% 57.14286%',
  '1F3B3': '34.28571% 57.14286%',
  '1F3B4': '37.14286% 57.14286%',
  '1F3B5': '40% 57.14286%',
  '1F3B6': '42.85714% 57.14286%',
  '1F3B7': '45.71429% 57.14286%',
  '1F3B8': '48.57143% 57.14286%',
  '1F3B9': '51.42857% 57.14286%',
  '1F3BA': '54.28571% 57.14286%',
  '1F3BB': '57.14286% 57.14286%',
  '1F3BC': '60% 0%',
  '1F3BD': '60% 2.85714%',
  '1F3BE': '60% 5.71429%',
  '1F3BF': '60% 8.57143%',
  '1F3C0': '60% 11.42857%',
  '1F3C1': '60% 14.28571%',
  '1F3C2': '60% 17.14286%',
  '1F3C3': '60% 20%',
  '1F3C4': '60% 22.85714%',
  '1F3C5': '60% 25.71429%',
  '1F3C6': '60% 28.57143%',
  '1F3C7': '60% 31.42857%',
  '1F3C8': '60% 34.28571%',
  '1F3C9': '60% 37.14286%',
  '1F3CA': '60% 40%',
  '1F3CB': '60% 42.85714%',
  '1F3CC': '60% 45.71429%',
  '1F3CD': '60% 48.57143%',
  '1F3CE': '60% 51.42857%',
  '1F3D4': '60% 54.28571%',
  '1F3D5': '60% 57.14286%',
  '1F3D6': '0% 60%',
  '1F3D7': '2.85714% 60%',
  '1F3D8': '5.71429% 60%',
  '1F3D9': '8.57143% 60%',
  '1F3DA': '11.42857% 60%',
  '1F3DB': '14.28571% 60%',
  '1F3DC': '17.14286% 60%',
  '1F3DD': '20% 60%',
  '1F3DE': '22.85714% 60%',
  '1F3DF': '25.71429% 60%',
  '1F3E0': '28.57143% 60%',
  '1F3E1': '31.42857% 60%',
  '1F3E2': '34.28571% 60%',
  '1F3E3': '37.14286% 60%',
  '1F3E4': '40% 60%',
  '1F3E5': '42.85714% 60%',
  '1F3E6': '45.71429% 60%',
  '1F3E7': '48.57143% 60%',
  '1F3E8': '51.42857% 60%',
  '1F3E9': '54.28571% 60%',
  '1F3EA': '57.14286% 60%',
  '1F3EB': '60% 60%',
  '1F3EC': '62.85714% 0%',
  '1F3ED': '62.85714% 2.85714%',
  '1F3EE': '62.85714% 5.71429%',
  '1F3EF': '62.85714% 8.57143%',
  '1F3F0': '62.85714% 11.42857%',
  '1F3F1': '62.85714% 14.28571%',
  '1F3F2': '62.85714% 17.14286%',
  '1F3F3': '62.85714% 20%',
  '1F3F4': '62.85714% 22.85714%',
  '1F3F5': '62.85714% 25.71429%',
  '1F3F6': '62.85714% 28.57143%',
  '1F3F7': '62.85714% 31.42857%',
  '1F400': '62.85714% 34.28571%',
  '1F401': '62.85714% 37.14286%',
  '1F402': '62.85714% 40%',
  '1F403': '62.85714% 42.85714%',
  '1F404': '62.85714% 45.71429%',
  '1F405': '62.85714% 48.57143%',
  '1F406': '62.85714% 51.42857%',
  '1F407': '62.85714% 54.28571%',
  '1F408': '62.85714% 57.14286%',
  '1F409': '62.85714% 60%',
  '1F40A': '0% 62.85714%',
  '1F40B': '2.85714% 62.85714%',
  '1F40C': '5.71429% 62.85714%',
  '1F40D': '8.57143% 62.85714%',
  '1F40E': '11.42857% 62.85714%',
  '1F40F': '14.28571% 62.85714%',
  '1F410': '17.14286% 62.85714%',
  '1F411': '20% 62.85714%',
  '1F412': '22.85714% 62.85714%',
  '1F413': '25.71429% 62.85714%',
  '1F414': '28.57143% 62.85714%',
  '1F415': '31.42857% 62.85714%',
  '1F416': '34.28571% 62.85714%',
  '1F417': '37.14286% 62.85714%',
  '1F418': '40% 62.85714%',
  '1F419': '42.85714% 62.85714%',
  '1F41A': '45.71429% 62.85714%',
  '1F41B': '48.57143% 62.85714%',
  '1F41C': '51.42857% 62.85714%',
  '1F41D': '54.28571% 62.85714%',
  '1F41E': '57.14286% 62.85714%',
  '1F41F': '60% 62.85714%',
  '1F420': '62.85714% 62.85714%',
  '1F421': '65.71429% 0%',
  '1F422': '65.71429% 2.85714%',
  '1F423': '65.71429% 5.71429%',
  '1F424': '65.71429% 8.57143%',
  '1F425': '65.71429% 11.42857%',
  '1F426': '65.71429% 14.28571%',
  '1F427': '65.71429% 17.14286%',
  '1F428': '65.71429% 20%',
  '1F429': '65.71429% 22.85714%',
  '1F42A': '65.71429% 25.71429%',
  '1F42B': '65.71429% 28.57143%',
  '1F42C': '65.71429% 31.42857%',
  '1F42D': '65.71429% 34.28571%',
  '1F42E': '65.71429% 37.14286%',
  '1F42F': '65.71429% 40%',
  '1F430': '65.71429% 42.85714%',
  '1F431': '65.71429% 45.71429%',
  '1F432': '65.71429% 48.57143%',
  '1F433': '65.71429% 51.42857%',
  '1F434': '65.71429% 54.28571%',
  '1F435': '65.71429% 57.14286%',
  '1F436': '65.71429% 60%',
  '1F437': '65.71429% 62.85714%',
  '1F438': '0% 65.71429%',
  '1F439': '2.85714% 65.71429%',
  '1F43A': '5.71429% 65.71429%',
  '1F43B': '8.57143% 65.71429%',
  '1F43C': '11.42857% 65.71429%',
  '1F43D': '14.28571% 65.71429%',
  '1F43E': '17.14286% 65.71429%',
  '1F43F': '20% 65.71429%',
  '1F440': '22.85714% 65.71429%',
  '1F441': '25.71429% 65.71429%',
  '1F442': '28.57143% 65.71429%',
  '1F443': '31.42857% 65.71429%',
  '1F444': '34.28571% 65.71429%',
  '1F445': '37.14286% 65.71429%',
  '1F446': '40% 65.71429%',
  '1F447': '42.85714% 65.71429%',
  '1F448': '45.71429% 65.71429%',
  '1F449': '48.57143% 65.71429%',
  '1F44A': '51.42857% 65.71429%',
  '1F44B': '54.28571% 65.71429%',
  '1F44C': '57.14286% 65.71429%',
  '1F44D': '60% 65.71429%',
  '1F44E': '62.85714% 65.71429%',
  '1F44F': '65.71429% 65.71429%',
  '1F450': '68.57143% 0%',
  '1F451': '68.57143% 2.85714%',
  '1F452': '68.57143% 5.71429%',
  '1F453': '68.57143% 8.57143%',
  '1F454': '68.57143% 11.42857%',
  '1F455': '68.57143% 14.28571%',
  '1F456': '68.57143% 17.14286%',
  '1F457': '68.57143% 20%',
  '1F458': '68.57143% 22.85714%',
  '1F459': '68.57143% 25.71429%',
  '1F45A': '68.57143% 28.57143%',
  '1F45B': '68.57143% 31.42857%',
  '1F45C': '68.57143% 34.28571%',
  '1F45D': '68.57143% 37.14286%',
  '1F45E': '68.57143% 40%',
  '1F45F': '68.57143% 42.85714%',
  '1F460': '68.57143% 45.71429%',
  '1F461': '68.57143% 48.57143%',
  '1F462': '68.57143% 51.42857%',
  '1F463': '68.57143% 54.28571%',
  '1F464': '68.57143% 57.14286%',
  '1F465': '68.57143% 60%',
  '1F466': '68.57143% 62.85714%',
  '1F467': '68.57143% 65.71429%',
  '1F468-1F468-1F466-1F466': '0% 68.57143%',
  '1F468-1F468-1F466': '2.85714% 68.57143%',
  '1F468-1F468-1F467-1F466': '5.71429% 68.57143%',
  '1F468-1F468-1F467-1F467': '8.57143% 68.57143%',
  '1F468-1F468-1F467': '11.42857% 68.57143%',
  '1F468-1F469-1F466-1F466': '14.28571% 68.57143%',
  '1F468-1F469-1F467-1F466': '17.14286% 68.57143%',
  '1F468-1F469-1F467-1F467': '20% 68.57143%',
  '1F468-1F469-1F467': '22.85714% 68.57143%',
  '1F468-2764-1F468': '25.71429% 68.57143%',
  '1F468-2764-1F48B-1F468': '28.57143% 68.57143%',
  '1F468': '31.42857% 68.57143%',
  '1F469-1F469-1F466-1F466': '34.28571% 68.57143%',
  '1F469-1F469-1F466': '37.14286% 68.57143%',
  '1F469-1F469-1F467-1F466': '40% 68.57143%',
  '1F469-1F469-1F467-1F467': '42.85714% 68.57143%',
  '1F469-1F469-1F467': '45.71429% 68.57143%',
  '1F469-2764-1F469': '48.57143% 68.57143%',
  '1F469-2764-1F48B-1F469': '51.42857% 68.57143%',
  '1F469': '54.28571% 68.57143%',
  '1F46A': '57.14286% 68.57143%',
  '1F46B': '60% 68.57143%',
  '1F46C': '62.85714% 68.57143%',
  '1F46D': '65.71429% 68.57143%',
  '1F46E': '68.57143% 68.57143%',
  '1F46F': '71.42857% 0%',
  '1F470': '71.42857% 2.85714%',
  '1F471': '71.42857% 5.71429%',
  '1F472': '71.42857% 8.57143%',
  '1F473': '71.42857% 11.42857%',
  '1F474': '71.42857% 14.28571%',
  '1F475': '71.42857% 17.14286%',
  '1F476': '71.42857% 20%',
  '1F477': '71.42857% 22.85714%',
  '1F478': '71.42857% 25.71429%',
  '1F479': '71.42857% 28.57143%',
  '1F47A': '71.42857% 31.42857%',
  '1F47B': '71.42857% 34.28571%',
  '1F47C': '71.42857% 37.14286%',
  '1F47D': '71.42857% 40%',
  '1F47E': '71.42857% 42.85714%',
  '1F47F': '71.42857% 45.71429%',
  '1F480': '71.42857% 48.57143%',
  '1F481': '0% 0%',
  '1F482': '71.42857% 54.28571%',
  '1F483': '71.42857% 57.14286%',
  '1F484': '71.42857% 60%',
  '1F485': '71.42857% 62.85714%',
  '1F486': '71.42857% 65.71429%',
  '1F487': '71.42857% 68.57143%',
  '1F488': '0% 71.42857%',
  '1F489': '2.85714% 71.42857%',
  '1F48A': '5.71429% 71.42857%',
  '1F48B': '8.57143% 71.42857%',
  '1F48C': '11.42857% 71.42857%',
  '1F48D': '14.28571% 71.42857%',
  '1F48E': '17.14286% 71.42857%',
  '1F48F': '20% 71.42857%',
  '1F490': '22.85714% 71.42857%',
  '1F491': '25.71429% 71.42857%',
  '1F492': '28.57143% 71.42857%',
  '1F493': '31.42857% 71.42857%',
  '1F494': '34.28571% 71.42857%',
  '1F495': '37.14286% 71.42857%',
  '1F496': '40% 71.42857%',
  '1F497': '42.85714% 71.42857%',
  '1F498': '45.71429% 71.42857%',
  '1F499': '48.57143% 71.42857%',
  '1F49A': '51.42857% 71.42857%',
  '1F49B': '54.28571% 71.42857%',
  '1F49C': '57.14286% 71.42857%',
  '1F49D': '60% 71.42857%',
  '1F49E': '62.85714% 71.42857%',
  '1F49F': '65.71429% 71.42857%',
  '1F4A0': '68.57143% 71.42857%',
  '1F4A1': '71.42857% 71.42857%',
  '1F4A2': '74.28571% 0%',
  '1F4A3': '74.28571% 2.85714%',
  '1F4A4': '74.28571% 5.71429%',
  '1F4A5': '74.28571% 8.57143%',
  '1F4A6': '74.28571% 11.42857%',
  '1F4A7': '74.28571% 14.28571%',
  '1F4A8': '74.28571% 17.14286%',
  '1F4A9': '74.28571% 20%',
  '1F4AA': '74.28571% 22.85714%',
  '1F4AB': '74.28571% 25.71429%',
  '1F4AC': '74.28571% 28.57143%',
  '1F4AD': '74.28571% 31.42857%',
  '1F4AE': '74.28571% 34.28571%',
  '1F4AF': '74.28571% 37.14286%',
  '1F4B0': '74.28571% 40%',
  '1F4B1': '74.28571% 42.85714%',
  '1F4B2': '74.28571% 45.71429%',
  '1F4B3': '74.28571% 48.57143%',
  '1F4B4': '74.28571% 51.42857%',
  '1F4B5': '74.28571% 54.28571%',
  '1F4B6': '74.28571% 57.14286%',
  '1F4B7': '74.28571% 60%',
  '1F4B8': '74.28571% 62.85714%',
  '1F4B9': '74.28571% 65.71429%',
  '1F4BA': '74.28571% 68.57143%',
  '1F4BB': '74.28571% 71.42857%',
  '1F4BC': '0% 74.28571%',
  '1F4BD': '2.85714% 74.28571%',
  '1F4BE': '5.71429% 74.28571%',
  '1F4BF': '8.57143% 74.28571%',
  '1F4C0': '11.42857% 74.28571%',
  '1F4C1': '14.28571% 74.28571%',
  '1F4C2': '17.14286% 74.28571%',
  '1F4C3': '20% 74.28571%',
  '1F4C4': '22.85714% 74.28571%',
  '1F4C5': '25.71429% 74.28571%',
  '1F4C6': '28.57143% 74.28571%',
  '1F4C7': '31.42857% 74.28571%',
  '1F4C8': '34.28571% 74.28571%',
  '1F4C9': '37.14286% 74.28571%',
  '1F4CA': '40% 74.28571%',
  '1F4CB': '42.85714% 74.28571%',
  '1F4CC': '45.71429% 74.28571%',
  '1F4CD': '48.57143% 74.28571%',
  '1F4CE': '51.42857% 74.28571%',
  '1F4CF': '54.28571% 74.28571%',
  '1F4D0': '57.14286% 74.28571%',
  '1F4D1': '60% 74.28571%',
  '1F4D2': '62.85714% 74.28571%',
  '1F4D3': '65.71429% 74.28571%',
  '1F4D4': '68.57143% 74.28571%',
  '1F4D5': '71.42857% 74.28571%',
  '1F4D6': '74.28571% 74.28571%',
  '1F4D7': '77.14286% 0%',
  '1F4D8': '77.14286% 2.85714%',
  '1F4D9': '77.14286% 5.71429%',
  '1F4DA': '77.14286% 8.57143%',
  '1F4DB': '77.14286% 11.42857%',
  '1F4DC': '77.14286% 14.28571%',
  '1F4DD': '77.14286% 17.14286%',
  '1F4DE': '77.14286% 20%',
  '1F4DF': '77.14286% 22.85714%',
  '1F4E0': '77.14286% 25.71429%',
  '1F4E1': '77.14286% 28.57143%',
  '1F4E2': '77.14286% 31.42857%',
  '1F4E3': '77.14286% 34.28571%',
  '1F4E4': '77.14286% 37.14286%',
  '1F4E5': '77.14286% 40%',
  '1F4E6': '77.14286% 42.85714%',
  '1F4E7': '77.14286% 45.71429%',
  '1F4E8': '77.14286% 48.57143%',
  '1F4E9': '77.14286% 51.42857%',
  '1F4EA': '77.14286% 54.28571%',
  '1F4EB': '77.14286% 57.14286%',
  '1F4EC': '77.14286% 60%',
  '1F4ED': '77.14286% 62.85714%',
  '1F4EE': '77.14286% 65.71429%',
  '1F4EF': '77.14286% 68.57143%',
  '1F4F0': '77.14286% 71.42857%',
  '1F4F1': '77.14286% 74.28571%',
  '1F4F2': '0% 77.14286%',
  '1F4F3': '2.85714% 77.14286%',
  '1F4F4': '5.71429% 77.14286%',
  '1F4F5': '8.57143% 77.14286%',
  '1F4F6': '11.42857% 77.14286%',
  '1F4F7': '14.28571% 77.14286%',
  '1F4F8': '17.14286% 77.14286%',
  '1F4F9': '20% 77.14286%',
  '1F4FA': '22.85714% 77.14286%',
  '1F4FB': '25.71429% 77.14286%',
  '1F4FC': '28.57143% 77.14286%',
  '1F4FD': '31.42857% 77.14286%',
  '1F4FE': '34.28571% 77.14286%',
  '1F500': '37.14286% 77.14286%',
  '1F501': '40% 77.14286%',
  '1F502': '42.85714% 77.14286%',
  '1F503': '45.71429% 77.14286%',
  '1F504': '48.57143% 77.14286%',
  '1F505': '51.42857% 77.14286%',
  '1F506': '54.28571% 77.14286%',
  '1F507': '57.14286% 77.14286%',
  '1F508': '60% 77.14286%',
  '1F509': '62.85714% 77.14286%',
  '1F50A': '65.71429% 77.14286%',
  '1F50B': '68.57143% 77.14286%',
  '1F50C': '71.42857% 77.14286%',
  '1F50D': '74.28571% 77.14286%',
  '1F50E': '77.14286% 77.14286%',
  '1F50F': '80% 0%',
  '1F510': '80% 2.85714%',
  '1F511': '80% 5.71429%',
  '1F512': '80% 8.57143%',
  '1F513': '80% 11.42857%',
  '1F514': '80% 14.28571%',
  '1F515': '80% 17.14286%',
  '1F516': '80% 20%',
  '1F517': '80% 22.85714%',
  '1F518': '80% 25.71429%',
  '1F519': '80% 28.57143%',
  '1F51A': '80% 31.42857%',
  '1F51B': '80% 34.28571%',
  '1F51C': '80% 37.14286%',
  '1F51D': '80% 40%',
  '1F51E': '80% 42.85714%',
  '1F51F': '80% 45.71429%',
  '1F520': '80% 48.57143%',
  '1F521': '80% 51.42857%',
  '1F522': '80% 54.28571%',
  '1F523': '80% 57.14286%',
  '1F524': '80% 60%',
  '1F525': '80% 62.85714%',
  '1F526': '80% 65.71429%',
  '1F527': '80% 68.57143%',
  '1F528': '80% 71.42857%',
  '1F529': '80% 74.28571%',
  '1F52A': '80% 77.14286%',
  '1F52B': '0% 80%',
  '1F52C': '2.85714% 80%',
  '1F52D': '5.71429% 80%',
  '1F52E': '8.57143% 80%',
  '1F52F': '11.42857% 80%',
  '1F530': '14.28571% 80%',
  '1F531': '17.14286% 80%',
  '1F532': '20% 80%',
  '1F533': '22.85714% 80%',
  '1F534': '25.71429% 80%',
  '1F535': '28.57143% 80%',
  '1F536': '31.42857% 80%',
  '1F537': '34.28571% 80%',
  '1F538': '37.14286% 80%',
  '1F539': '40% 80%',
  '1F53A': '42.85714% 80%',
  '1F53B': '45.71429% 80%',
  '1F53C': '48.57143% 80%',
  '1F53D': '51.42857% 80%',
  '1F546': '54.28571% 80%',
  '1F547': '57.14286% 80%',
  '1F548': '60% 80%',
  '1F549': '62.85714% 80%',
  '1F54A': '65.71429% 80%',
  '1F550': '68.57143% 80%',
  '1F551': '71.42857% 80%',
  '1F552': '74.28571% 80%',
  '1F553': '77.14286% 80%',
  '1F554': '80% 80%',
  '1F555': '82.85714% 0%',
  '1F556': '82.85714% 2.85714%',
  '1F557': '82.85714% 5.71429%',
  '1F558': '82.85714% 8.57143%',
  '1F559': '82.85714% 11.42857%',
  '1F55A': '82.85714% 14.28571%',
  '1F55B': '82.85714% 17.14286%',
  '1F55C': '82.85714% 20%',
  '1F55D': '82.85714% 22.85714%',
  '1F55E': '82.85714% 25.71429%',
  '1F55F': '82.85714% 28.57143%',
  '1F560': '82.85714% 31.42857%',
  '1F561': '82.85714% 34.28571%',
  '1F562': '82.85714% 37.14286%',
  '1F563': '82.85714% 40%',
  '1F564': '82.85714% 42.85714%',
  '1F565': '82.85714% 45.71429%',
  '1F566': '82.85714% 48.57143%',
  '1F567': '82.85714% 51.42857%',
  '1F568': '82.85714% 54.28571%',
  '1F569': '82.85714% 57.14286%',
  '1F56A': '82.85714% 60%',
  '1F56B': '82.85714% 62.85714%',
  '1F56C': '82.85714% 65.71429%',
  '1F56D': '82.85714% 68.57143%',
  '1F56E': '82.85714% 71.42857%',
  '1F56F': '82.85714% 74.28571%',
  '1F570': '82.85714% 77.14286%',
  '1F571': '82.85714% 80%',
  '1F572': '0% 82.85714%',
  '1F573': '2.85714% 82.85714%',
  '1F574': '5.71429% 82.85714%',
  '1F575': '8.57143% 82.85714%',
  '1F576': '11.42857% 82.85714%',
  '1F577': '14.28571% 82.85714%',
  '1F578': '17.14286% 82.85714%',
  '1F579': '20% 82.85714%',
  '1F57B': '22.85714% 82.85714%',
  '1F57E': '25.71429% 82.85714%',
  '1F57F': '28.57143% 82.85714%',
  '1F581': '31.42857% 82.85714%',
  '1F582': '34.28571% 82.85714%',
  '1F583': '37.14286% 82.85714%',
  '1F585': '40% 82.85714%',
  '1F586': '42.85714% 82.85714%',
  '1F587': '45.71429% 82.85714%',
  '1F588': '48.57143% 82.85714%',
  '1F589': '51.42857% 82.85714%',
  '1F58A': '54.28571% 82.85714%',
  '1F58B': '57.14286% 82.85714%',
  '1F58C': '60% 82.85714%',
  '1F58D': '62.85714% 82.85714%',
  '1F58E': '65.71429% 82.85714%',
  '1F58F': '68.57143% 82.85714%',
  '1F590': '71.42857% 82.85714%',
  '1F591': '74.28571% 82.85714%',
  '1F592': '77.14286% 82.85714%',
  '1F593': '80% 82.85714%',
  '1F594': '82.85714% 82.85714%',
  '1F595': '85.71429% 0%',
  '1F596': '85.71429% 2.85714%',
  '1F597': '85.71429% 5.71429%',
  '1F598': '85.71429% 8.57143%',
  '1F599': '85.71429% 11.42857%',
  '1F59E': '85.71429% 14.28571%',
  '1F59F': '85.71429% 17.14286%',
  '1F5A5': '85.71429% 20%',
  '1F5A6': '85.71429% 22.85714%',
  '1F5A7': '85.71429% 25.71429%',
  '1F5A8': '85.71429% 28.57143%',
  '1F5A9': '85.71429% 31.42857%',
  '1F5AA': '85.71429% 34.28571%',
  '1F5AB': '85.71429% 37.14286%',
  '1F5AD': '85.71429% 40%',
  '1F5AE': '85.71429% 42.85714%',
  '1F5AF': '85.71429% 45.71429%',
  '1F5B2': '85.71429% 48.57143%',
  '1F5B3': '85.71429% 51.42857%',
  '1F5B4': '85.71429% 54.28571%',
  '1F5B8': '85.71429% 57.14286%',
  '1F5B9': '85.71429% 60%',
  '1F5BC': '85.71429% 62.85714%',
  '1F5BD': '85.71429% 65.71429%',
  '1F5BE': '85.71429% 68.57143%',
  '1F5C0': '85.71429% 71.42857%',
  '1F5C1': '85.71429% 74.28571%',
  '1F5C2': '85.71429% 77.14286%',
  '1F5C3': '85.71429% 80%',
  '1F5C4': '85.71429% 82.85714%',
  '1F5C6': '0% 85.71429%',
  '1F5C7': '2.85714% 85.71429%',
  '1F5C9': '5.71429% 85.71429%',
  '1F5CA': '8.57143% 85.71429%',
  '1F5CE': '11.42857% 85.71429%',
  '1F5CF': '14.28571% 85.71429%',
  '1F5D0': '17.14286% 85.71429%',
  '1F5D1': '20% 85.71429%',
  '1F5D2': '22.85714% 85.71429%',
  '1F5D3': '25.71429% 85.71429%',
  '1F5D4': '28.57143% 85.71429%',
  '1F5D8': '31.42857% 85.71429%',
  '1F5D9': '34.28571% 85.71429%',
  '1F5DC': '37.14286% 85.71429%',
  '1F5DD': '40% 85.71429%',
  '1F5DE': '42.85714% 85.71429%',
  '1F5E0': '45.71429% 85.71429%',
  '1F5E1': '48.57143% 85.71429%',
  '1F5E2': '51.42857% 85.71429%',
  '1F5E3': '54.28571% 85.71429%',
  '1F5E8': '57.14286% 85.71429%',
  '1F5E9': '60% 85.71429%',
  '1F5EA': '62.85714% 85.71429%',
  '1F5EB': '65.71429% 85.71429%',
  '1F5EC': '68.57143% 85.71429%',
  '1F5ED': '71.42857% 85.71429%',
  '1F5EE': '74.28571% 85.71429%',
  '1F5EF': '77.14286% 85.71429%',
  '1F5F0': '80% 85.71429%',
  '1F5F1': '82.85714% 85.71429%',
  '1F5F2': '85.71429% 85.71429%',
  '1F5F3': '88.57143% 0%',
  '1F5F4': '88.57143% 2.85714%',
  '1F5F5': '88.57143% 5.71429%',
  '1F5F8': '88.57143% 8.57143%',
  '1F5F9': '88.57143% 11.42857%',
  '1F5FA': '88.57143% 14.28571%',
  '1F5FB': '88.57143% 17.14286%',
  '1F5FC': '88.57143% 20%',
  '1F5FD': '88.57143% 22.85714%',
  '1F5FE': '88.57143% 25.71429%',
  '1F5FF': '88.57143% 28.57143%',
  '1F600': '88.57143% 31.42857%',
  '1F601': '88.57143% 34.28571%',
  '1F602': '88.57143% 37.14286%',
  '1F603': '88.57143% 40%',
  '1F604': '88.57143% 42.85714%',
  '1F605': '88.57143% 45.71429%',
  '1F606': '88.57143% 48.57143%',
  '1F607': '88.57143% 51.42857%',
  '1F608': '88.57143% 54.28571%',
  '1F609': '88.57143% 57.14286%',
  '1F60A': '88.57143% 60%',
  '1F60B': '88.57143% 62.85714%',
  '1F60C': '88.57143% 65.71429%',
  '1F60D': '88.57143% 68.57143%',
  '1F60E': '88.57143% 71.42857%',
  '1F60F': '88.57143% 74.28571%',
  '1F610': '88.57143% 77.14286%',
  '1F611': '88.57143% 80%',
  '1F612': '88.57143% 82.85714%',
  '1F613': '88.57143% 85.71429%',
  '1F614': '0% 88.57143%',
  '1F615': '2.85714% 88.57143%',
  '1F616': '5.71429% 88.57143%',
  '1F617': '8.57143% 88.57143%',
  '1F618': '11.42857% 88.57143%',
  '1F619': '14.28571% 88.57143%',
  '1F61A': '17.14286% 88.57143%',
  '1F61B': '20% 88.57143%',
  '1F61C': '22.85714% 88.57143%',
  '1F61D': '25.71429% 88.57143%',
  '1F61E': '28.57143% 88.57143%',
  '1F61F': '31.42857% 88.57143%',
  '1F620': '34.28571% 88.57143%',
  '1F621': '37.14286% 88.57143%',
  '1F622': '40% 88.57143%',
  '1F623': '42.85714% 88.57143%',
  '1F624': '45.71429% 88.57143%',
  '1F625': '48.57143% 88.57143%',
  '1F626': '51.42857% 88.57143%',
  '1F627': '54.28571% 88.57143%',
  '1F628': '57.14286% 88.57143%',
  '1F629': '60% 88.57143%',
  '1F62A': '62.85714% 88.57143%',
  '1F62B': '65.71429% 88.57143%',
  '1F62C': '68.57143% 88.57143%',
  '1F62D': '71.42857% 88.57143%',
  '1F62E': '74.28571% 88.57143%',
  '1F62F': '77.14286% 88.57143%',
  '1F630': '80% 88.57143%',
  '1F631': '82.85714% 88.57143%',
  '1F632': '85.71429% 88.57143%',
  '1F633': '88.57143% 88.57143%',
  '1F634': '91.42857% 0%',
  '1F635': '91.42857% 2.85714%',
  '1F636': '91.42857% 5.71429%',
  '1F637': '91.42857% 8.57143%',
  '1F638': '91.42857% 11.42857%',
  '1F639': '91.42857% 14.28571%',
  '1F63A': '91.42857% 17.14286%',
  '1F63B': '91.42857% 20%',
  '1F63C': '91.42857% 22.85714%',
  '1F63D': '91.42857% 25.71429%',
  '1F63E': '91.42857% 28.57143%',
  '1F63F': '91.42857% 31.42857%',
  '1F640': '91.42857% 34.28571%',
  '1F641': '91.42857% 37.14286%',
  '1F642': '91.42857% 40%',
  '1F645': '91.42857% 42.85714%',
  '1F646': '91.42857% 45.71429%',
  '1F647': '91.42857% 48.57143%',
  '1F648': '91.42857% 51.42857%',
  '1F649': '91.42857% 54.28571%',
  '1F64A': '91.42857% 57.14286%',
  '1F64B': '91.42857% 60%',
  '1F64C': '91.42857% 62.85714%',
  '1F64D': '91.42857% 65.71429%',
  '1F64E': '91.42857% 68.57143%',
  '1F64F': '91.42857% 71.42857%',
  '1F680': '91.42857% 74.28571%',
  '1F681': '91.42857% 77.14286%',
  '1F682': '91.42857% 80%',
  '1F683': '91.42857% 82.85714%',
  '1F684': '91.42857% 85.71429%',
  '1F685': '91.42857% 88.57143%',
  '1F686': '0% 91.42857%',
  '1F687': '2.85714% 91.42857%',
  '1F688': '5.71429% 91.42857%',
  '1F689': '8.57143% 91.42857%',
  '1F68A': '11.42857% 91.42857%',
  '1F68B': '14.28571% 91.42857%',
  '1F68C': '17.14286% 91.42857%',
  '1F68D': '20% 91.42857%',
  '1F68E': '22.85714% 91.42857%',
  '1F68F': '25.71429% 91.42857%',
  '1F690': '28.57143% 91.42857%',
  '1F691': '31.42857% 91.42857%',
  '1F692': '34.28571% 91.42857%',
  '1F693': '37.14286% 91.42857%',
  '1F694': '40% 91.42857%',
  '1F695': '42.85714% 91.42857%',
  '1F696': '45.71429% 91.42857%',
  '1F697': '48.57143% 91.42857%',
  '1F698': '51.42857% 91.42857%',
  '1F699': '54.28571% 91.42857%',
  '1F69A': '57.14286% 91.42857%',
  '1F69B': '60% 91.42857%',
  '1F69C': '62.85714% 91.42857%',
  '1F69D': '65.71429% 91.42857%',
  '1F69E': '68.57143% 91.42857%',
  '1F69F': '71.42857% 91.42857%',
  '1F6A0': '74.28571% 91.42857%',
  '1F6A1': '77.14286% 91.42857%',
  '1F6A2': '80% 91.42857%',
  '1F6A3': '82.85714% 91.42857%',
  '1F6A4': '85.71429% 91.42857%',
  '1F6A5': '88.57143% 91.42857%',
  '1F6A6': '91.42857% 91.42857%',
  '1F6A7': '94.28571% 0%',
  '1F6A8': '94.28571% 2.85714%',
  '1F6A9': '94.28571% 5.71429%',
  '1F6AA': '94.28571% 8.57143%',
  '1F6AB': '94.28571% 11.42857%',
  '1F6AC': '94.28571% 14.28571%',
  '1F6AD': '94.28571% 17.14286%',
  '1F6AE': '94.28571% 20%',
  '1F6AF': '94.28571% 22.85714%',
  '1F6B0': '94.28571% 25.71429%',
  '1F6B1': '94.28571% 28.57143%',
  '1F6B2': '94.28571% 31.42857%',
  '1F6B3': '94.28571% 34.28571%',
  '1F6B4': '94.28571% 37.14286%',
  '1F6B5': '94.28571% 40%',
  '1F6B6': '94.28571% 42.85714%',
  '1F6B7': '94.28571% 45.71429%',
  '1F6B8': '94.28571% 48.57143%',
  '1F6B9': '94.28571% 51.42857%',
  '1F6BA': '94.28571% 54.28571%',
  '1F6BB': '94.28571% 57.14286%',
  '1F6BC': '94.28571% 60%',
  '1F6BD': '94.28571% 62.85714%',
  '1F6BE': '94.28571% 65.71429%',
  '1F6BF': '94.28571% 68.57143%',
  '1F6C0': '94.28571% 71.42857%',
  '1F6C1': '94.28571% 74.28571%',
  '1F6C2': '94.28571% 77.14286%',
  '1F6C3': '94.28571% 80%',
  '1F6C4': '94.28571% 82.85714%',
  '1F6C5': '94.28571% 85.71429%',
  '1F6C6': '94.28571% 88.57143%',
  '1F6C7': '94.28571% 91.42857%',
  '1F6C8': '0% 94.28571%',
  '1F6C9': '2.85714% 94.28571%',
  '1F6CA': '5.71429% 94.28571%',
  '1F6CB': '8.57143% 94.28571%',
  '1F6CC': '11.42857% 94.28571%',
  '1F6CD': '14.28571% 94.28571%',
  '1F6CE': '17.14286% 94.28571%',
  '1F6CF': '20% 94.28571%',
  '1F6E0': '22.85714% 94.28571%',
  '1F6E1': '25.71429% 94.28571%',
  '1F6E2': '28.57143% 94.28571%',
  '1F6E3': '31.42857% 94.28571%',
  '1F6E4': '34.28571% 94.28571%',
  '1F6E5': '37.14286% 94.28571%',
  '1F6E6': '40% 94.28571%',
  '1F6E7': '42.85714% 94.28571%',
  '1F6E8': '45.71429% 94.28571%',
  '1F6E9': '48.57143% 94.28571%',
  '1F6EA': '51.42857% 94.28571%',
  '1F6EB': '54.28571% 94.28571%',
  '1F6EC': '57.14286% 94.28571%',
  '1F6F0': '60% 94.28571%',
  '1F6F1': '62.85714% 94.28571%',
  '1F6F2': '65.71429% 94.28571%',
  '1F6F3': '68.57143% 94.28571%',
  '203C': '71.42857% 94.28571%',
  '2049': '74.28571% 94.28571%',
  '2122': '77.14286% 94.28571%',
  '2139': '80% 94.28571%',
  '2194': '82.85714% 94.28571%',
  '2195': '85.71429% 94.28571%',
  '2196': '88.57143% 94.28571%',
  '2197': '91.42857% 94.28571%',
  '2198': '94.28571% 94.28571%',
  '2199': '97.14286% 0%',
  '21A9': '97.14286% 2.85714%',
  '21AA': '97.14286% 5.71429%',
  '231A': '97.14286% 8.57143%',
  '231B': '97.14286% 11.42857%',
  '23E9': '97.14286% 14.28571%',
  '23EA': '97.14286% 17.14286%',
  '23EB': '97.14286% 20%',
  '23EC': '97.14286% 22.85714%',
  '23F0': '97.14286% 25.71429%',
  '23F3': '97.14286% 28.57143%',
  '24C2': '97.14286% 31.42857%',
  '25AA': '97.14286% 34.28571%',
  '25AB': '97.14286% 37.14286%',
  '25B6': '97.14286% 40%',
  '25C0': '97.14286% 42.85714%',
  '25FB': '97.14286% 45.71429%',
  '25FC': '97.14286% 48.57143%',
  '25FD': '97.14286% 51.42857%',
  '25FE': '97.14286% 54.28571%',
  '2600': '97.14286% 57.14286%',
  '2601': '97.14286% 60%',
  '260E': '97.14286% 62.85714%',
  '2611': '97.14286% 65.71429%',
  '2614': '97.14286% 68.57143%',
  '2615': '97.14286% 71.42857%',
  '261D': '97.14286% 74.28571%',
  '263A': '97.14286% 77.14286%',
  '2648': '97.14286% 80%',
  '2649': '97.14286% 82.85714%',
  '264A': '97.14286% 85.71429%',
  '264B': '97.14286% 88.57143%',
  '264C': '97.14286% 91.42857%',
  '264D': '97.14286% 94.28571%',
  '264E': '0% 97.14286%',
  '264F': '2.85714% 97.14286%',
  '2650': '5.71429% 97.14286%',
  '2651': '8.57143% 97.14286%',
  '2652': '11.42857% 97.14286%',
  '2653': '14.28571% 97.14286%',
  '2660': '17.14286% 97.14286%',
  '2663': '20% 97.14286%',
  '2665': '22.85714% 97.14286%',
  '2666': '25.71429% 97.14286%',
  '2668': '28.57143% 97.14286%',
  '267B': '31.42857% 97.14286%',
  '267F': '34.28571% 97.14286%',
  '2693': '37.14286% 97.14286%',
  '26A0': '40% 97.14286%',
  '26A1': '42.85714% 97.14286%',
  '26AA': '45.71429% 97.14286%',
  '26AB': '48.57143% 97.14286%',
  '26BD': '51.42857% 97.14286%',
  '26BE': '54.28571% 97.14286%',
  '26C4': '57.14286% 97.14286%',
  '26C5': '60% 97.14286%',
  '26CE': '62.85714% 97.14286%',
  '26D4': '65.71429% 97.14286%',
  '26EA': '68.57143% 97.14286%',
  '26F2': '71.42857% 97.14286%',
  '26F3': '74.28571% 97.14286%',
  '26F5': '77.14286% 97.14286%',
  '26FA': '80% 97.14286%',
  '26FD': '82.85714% 97.14286%',
  '2702': '85.71429% 97.14286%',
  '2705': '88.57143% 97.14286%',
  '2708': '91.42857% 97.14286%',
  '2709': '94.28571% 97.14286%',
  '270A': '97.14286% 97.14286%',
  '270B': '100% 0%',
  '270C': '100% 2.85714%',
  '270F': '100% 5.71429%',
  '2712': '100% 8.57143%',
  '2714': '100% 11.42857%',
  '2716': '100% 14.28571%',
  '2728': '100% 17.14286%',
  '2733': '100% 20%',
  '2734': '100% 22.85714%',
  '2744': '100% 25.71429%',
  '2747': '100% 28.57143%',
  '274C': '100% 31.42857%',
  '274E': '100% 34.28571%',
  '2753': '100% 37.14286%',
  '2754': '100% 40%',
  '2755': '100% 42.85714%',
  '2757': '100% 45.71429%',
  '2764': '100% 48.57143%',
  '2795': '100% 51.42857%',
  '2796': '100% 54.28571%',
  '2797': '100% 57.14286%',
  '27A1': '100% 60%',
  '27B0': '100% 62.85714%',
  '27BF': '100% 65.71429%',
  '2934': '100% 68.57143%',
  '2935': '100% 71.42857%',
  '2B05': '100% 74.28571%',
  '2B06': '100% 77.14286%',
  '2B07': '100% 80%',
  '2B1B': '100% 82.85714%',
  '2B1C': '100% 85.71429%',
  '2B50': '100% 88.57143%',
  '2B55': '100% 91.42857%',
  '3030': '100% 94.28571%',
  '303D': '100% 97.14286%',
  '3297': '0% 100%',
  '3299': '2.85714% 100%' };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-emojione/lib/styles/emojione-sprite-positions.js
 ** module id = ./node_modules/react-emojione/lib/styles/emojione-sprite-positions.js
 ** module chunks = 1
 **/